export var Actions;
(function (Actions) {
    Actions["UPLOAD_IMAGE"] = "postUploadImageAction";
})(Actions || (Actions = {}));
